/** 手机使用要求：记录按字段阅读，金额/薪资对比保留横向表；弹窗表单可换行、主要操作便于触控。只调整显示，不改变数据、权限及审批规则。 */
import React, { useState } from "react";
import { ChevronDown, ChevronRight, Folder, FolderOpen, Building2 } from "lucide-react";

const ymLabel = (ym, zh) => { const [y, m] = ym.split("-"); return zh ? `${y} 年 ${Number(m)} 月` : `${m}/${y}`; };

/* 「法人 → 年月」两级文件夹树（由归档列表即时汇总，含数量） */
export const HrArchiveTree = ({ list, folder, setFolder, zh }) => {
  const T = (a, b) => (zh ? a : b);
  const [openB, setOpenB] = useState({});
  const tree = {};
  list.forEach((a) => {
    const b = a.branch || "all";
    tree[b] = tree[b] || { name: a.branchName || (b === "all" ? T("全部法人", "All entities") : b), count: 0, yms: {} };
    tree[b].count += 1;
    if (a.ym) tree[b].yms[a.ym] = (tree[b].yms[a.ym] || 0) + 1;
  });
  const branches = Object.entries(tree).sort((x, y) => (x[0] === "all") - (y[0] === "all") || x[1].name.localeCompare(y[1].name, "zh"));
  const item = (active) => `w-full flex items-center gap-1.5 px-2 py-1 rounded text-left text-[11px] ${active ? "bg-amber-100 text-amber-900 font-semibold" : "text-slate-600 hover:bg-slate-50"}`;
  return (
    <div className="w-52 shrink-0 border-r border-slate-100 p-1.5 space-y-0.5 max-h-72 overflow-y-auto" data-testid="hrms-archive-tree">
      <button type="button" data-testid="hrms-archive-folder-all" onClick={() => setFolder({ branch: "", ym: "" })} className={item(!folder.branch)}>
        <FolderOpen className="h-3.5 w-3.5 text-amber-500" />{T("全部归档", "All files")}<span className="ml-auto text-slate-400">{list.length}</span>
      </button>
      {branches.map(([b, node]) => {
        const open = openB[b] ?? folder.branch === b;
        return (
          <div key={b}>
            <div className="flex-wrap md:flex-nowrap flex items-center">
              <button type="button" onClick={() => setOpenB((o) => ({ ...o, [b]: !open }))} className="p-0.5 text-slate-400" aria-label="toggle">{open ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />}</button>
              <button type="button" data-testid={`hrms-archive-folder-${b}`} data-count={node.count} onClick={() => { setFolder({ branch: b, ym: "" }); setOpenB((o) => ({ ...o, [b]: true })); }} className={item(folder.branch === b && !folder.ym)}>
                <Building2 className="h-3.5 w-3.5 text-slate-400" /><span className="truncate">{node.name}</span><span className="ml-auto text-slate-400">{node.count}</span>
              </button>
            </div>
            {open && Object.entries(node.yms).sort((x, y) => y[0].localeCompare(x[0])).map(([ym, n]) => (
              <button key={ym} type="button" data-testid={`hrms-archive-folder-${b}-${ym}`} data-count={n} onClick={() => setFolder({ branch: b, ym })} className={`min-h-11 min-w-11 md:min-h-0 md:min-w-0 ${item(folder.branch === b && folder.ym === ym)} pl-8`}>
                <Folder className="h-3 w-3 text-amber-400" />{ymLabel(ym, zh)}<span className="ml-auto text-slate-400">{n}</span>
              </button>
            ))}
          </div>
        );
      })}
    </div>
  );
};
